module.exports = __webpack_public_path__ + "static/media/kudos-next.8cdc6e12.svg";